<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="6" v-if="isDeviceChart">
                <div>Dispositivo</div>
                <p class="text-h4 text--primary">
                    {{ deviceName }}
                </p>
                <p class="font-weight-light" v-show="false">{{ deviceLastReport | dateFormat }}</p>
            </v-col>
            <v-col cols="12" sm="6" v-else>
                <p class="text-h4 text--primary">
                    Comparación de dispositivos
                </p>
            </v-col>
            <v-col cols="12" v-show="isLoading">
                <v-skeleton-loader type="image"></v-skeleton-loader>
                <v-skeleton-loader type="image"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" v-show="!isLoading">
                <apexchart ref="chart" height="400px" :options="options" :series="series"></apexchart>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import axios from 'axios'
import authHeader from '../../services/authHeader';
import settings from '@/constants/settings.js'
import colors from '@/constants/colorPalette.js'

export default {
    name: 'SimpleChars',
    props: {
        deviceId: String,
        devices: Array,
    },
    data: () => ({
        options: {
            colors: colors.CHART_COLORS,
            markers: {
                showNullDataPoints: false,
            },
            stroke: {
                width: [2, 2, 2, 2, 2],
                curve: 'straight'
            },
            chart: {
                type: 'line',
                id: 'hA',
                group: 'social',
            },
            yaxis: {
                labels: {
                    minWidth: 0,
                    formatter: function (value) {
                        return value.toFixed(1) + ""
                    }
                },
                title: {
                    text: 'Decibeles [dBA]',
                },
                min: 45,
                max: 90,
            },
            xaxis: {
                type: 'datetime',
                tickAmount: 1,
                labels: {
                    show: true,
                    datetimeUTC: false,
                    format: 'HH:mm:ss',
                }
            },
            tooltip: {
                x: {
                    format: "HH:mm:ss"
                }
            },
        },
        series: [],
        Laeqfs: [],
        deviceName: ''
    }),

    methods: {
        async getDevicesData() {
            let dataloca = []
            const currentDay = moment().format("YYYY-MM-DD")

            if ( this.devices ) {
                for (let i = 0; i < this.devices.length; i++) {
                    const device = this.devices[i]

                    if ( device in this.dashBoardDevices ) {
                        dataloca.push({
                            deviceId: device,
                            info: this.dashBoardDevices[device]
                        })
                    }
                }
            } else {
                const url = `${settings.URL_API}/report/${this.deviceId}/laeq_001?day=${currentDay}`
                const response = await axios.get(url, { headers: authHeader() })
                const data = {
                    deviceId: this.deviceId,
                    info: response.data
                }

                this.$store.dispatch('saveDashboardData', data)
                dataloca.push(data)
            }

            this.dataCharts2(dataloca)
        },

        dataCharts2(data) {

            this.series = []

            for (let j = 0; j < data.length; j++) {
                let Laeqfs = []
                const devicesInfo = this.findDeviceInfo(data[j].deviceId)

                if (!devicesInfo)
                    return

                this.deviceName = devicesInfo.name

                const laeqSensor = devicesInfo.sensors.find(e => {
                    return e.sensorType === 'laeq'
                }).sensorName

                let offsetloco = this.laeqOffset(data[j].deviceId, laeqSensor)
                const info = data[j].info

                if (info.length === 0)
                    continue

                for (let i = 0; i < info.length; i++) {
                    const laqeValue = info[i].report.avg + offsetloco
                    let laqeValuePre = laqeValue
                    

                    if (i > 0)
                        laqeValuePre = info[i - 1].report.avg + offsetloco

                    this.minLaeqfs = laqeValue < this.minLaeqfs ? laqeValue : this.minLaeqfs
                    let laeqSensorValue
                    let laeqFilter

                    if (!Object.hasOwnProperty.call(devicesInfo, "laeqFilter")) {
                        laeqFilter = {
                            max: 100,
                            min: 0
                        }
                    } else {
                        laeqFilter = devicesInfo.laeqFilter
                    }

                    if (laqeValue > laeqFilter.max || laqeValue < laeqFilter.min)
                        laeqSensorValue = null
                    else
                        laeqSensorValue = laqeValue

                    Laeqfs.push({
                        str: info[i].ts,
                        x: new Date(info[i].ts).getTime(),
                        y: laeqSensorValue
                    })
                }
                
                this.series.push({
                    type: 'line',
                    name: devicesInfo.name,
                    data: Laeqfs,
                    color: devicesInfo.info.color,
                    _p: devicesInfo.info.displayRank
                })

                
            }

            this.series.sort((a, b) => b._p - a._p)
            this.$store.dispatch('handleLoading', false)
        },

        laeqOffset(deviceId, sensorName) {
            const findSensor = this.allSensors.filter(sensor => sensor.deviceId === deviceId && sensor.sensorName === sensorName)

            if (findSensor.length > 0)
                return findSensor[0].offset

            return 0
        },

        findDeviceInfo(deviceId) {
            return this.$store.getters.device(deviceId)
        },
    },

    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },

        hasDevices () {
            return this.devices.length ? this.devices.length : 0
        },

        devicesInfo () {
            return this.$store.getters.devicesInfo
        },

        deviceLastReport () {
            return this.devicesInfo[this.deviceId]
        },

        allSensors () {
            return this.$store.getters.allSensors
        },

        dashBoardDevices () {
            return this.$store.getters.dashBoardDevices
        },

        isDeviceChart () {
            return !this.devices || this.devices.length === 0
        }
    },

    watch: {
        
    },

    filters: {
        dateFormat (val) {
            if ( !val )
                return "Sin Datos"

            if (!moment(val).isValid())
                return val

            return moment(val).format('LLL')
        },
    },

    components: {
        apexchart: VueApexCharts
    },

    created() {
        moment.locale('es-us')
        this.getDevicesData()

        setTimeout(this.getDevicesData, 60000)
    }
}
</script>
